'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Button } from '@/components/ui/button'
import { Home } from '@carbon/icons-react'
import { useTheme } from 'next-themes'
import { useMounted } from '@/lib/opendocs/hooks/use-mounted'
import { cn } from '@/lib/utils'

export default function NotFound() {
  const { resolvedTheme } = useTheme()
  const mounted = useMounted()

  // Default to dark theme for SSR to match the site default
  const isDark = mounted ? resolvedTheme === 'dark' : true

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background overflow-hidden">
      <div className="flex flex-col items-center justify-center gap-8 px-4 w-full h-full">
        {/* 404 Illustration - Much Larger */}
        <div className="relative w-[80%] h-[60vh] max-w-[1000px]">
          <Image
            src="/illustrations/404.svg"
            alt="404 - Page Not Found"
            fill
            className="object-contain"
            priority
          />
        </div>

        {/* Back to Home Button - Matching website aesthetics */}
        <Link href="/">
          <Button
            className={cn(
              'h-12 rounded-md border-2 px-8 text-base font-semibold transition-all gap-2',
              isDark
                ? 'bg-[#37ecb0] border-[#37ecb0] text-[#141417] hover:bg-[#37ecb0] hover:border-[#37ecb0] hover:shadow-lg'
                : 'bg-[#37ecb0] border-[#37ecb0] text-[#141417] hover:bg-[#37ecb0] hover:border-[#37ecb0] hover:shadow-lg hover:shadow-[#37ecb0]/50'
            )}
          >
            <Home className="h-5 w-5" />
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  )
}
